import { render } from "./TabHistorial.vue?vue&type=template&id=2a7b48f3&scoped=true"
import script from "./TabHistorial.vue?vue&type=script&lang=js"
export * from "./TabHistorial.vue?vue&type=script&lang=js"

import "./TabHistorial.vue?vue&type=style&index=0&id=2a7b48f3&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a7b48f3"]])

export default __exports__